import { createAction, props } from '@ngrx/store';

import { LineItemRequest } from '../../../objects/line-item-request';
import { BookingRequest } from '../../../objects/booking-request';
import { Order } from '../../../objects/order';

import { Booking } from '../../../objects/booking';
import { LineItem } from '../../../objects/line-item';

import { DeliveryAddress } from 'src/objects/custom-destination';
import { TipUpdatedEvent } from 'src/app/cart/cart-tip/cart-tip.component';


export class CreateOrderForDeliveryDestinationPayload {
  warehouseId: number;
  address?: DeliveryAddress;
  slug: string;
  
  constructor(args: { warehouseId: number; address?: DeliveryAddress; slug: string }) {
    this.warehouseId = args.warehouseId;
    this.address = args.address;
    this.slug = args.slug;
  }
}

export class CreateOrderForDestinationPayload {
  destinationId: number;
  slug: string;
  
  constructor(args: { destinationId: number, slug: string }) {
    this.destinationId = args.destinationId;
    this.slug = args.slug;
  }
}

export type CreateOrderPayload = CreateOrderForDeliveryDestinationPayload | CreateOrderForDestinationPayload;

/**
 * Create order
 */
export const createOrder = createAction(
  '[Order] Create Order',
  props<{payload: CreateOrderPayload}>(),
);

export const createOrderSuccess = createAction(
  '[Order] Create Order Success',
  props<{order: Order}>(),
);

export const createOrderFailure = createAction(
  '[Order] Create Order Failure',
  props<{error: Error}>(),
);

/**
 * Clear order
 */

 export const clearOrder = createAction(
  '[Order] Clear Order',
);


/**
 * Clear updating tip error
 */
export const clearUpdatingTipError = createAction(
  '[Order] Clear Updating Tip Error',
);

/**
 * Load order
 */
export const loadOrder = createAction(
  '[Order] Load Order',
  props<{token: string}>(),
);

export const loadOrderSuccess = createAction(
  '[Order] Load Order Success',
  props<{order: Order}>(),
);

export const loadOrderFailure = createAction(
  '[Order] Load Order Failure',
  props<{error: Error}>(),
);

/**
 * Load completed order
 */
export const loadCompletedOrder = createAction(
  '[Order] Load Completed Order',
  props<{orderNumber: string}>(),
);

export const loadCompletedOrderSuccess = createAction(
  '[Order] Load Completed Order Success',
  props<{completedOrder: Order}>(),
);

export const loadCompletedOrderFailure = createAction(
  '[Order] Load Completed Order Failure',
  props<{error: Error}>(),
);

/**
 * Add item to an order
 */
export const addItem = createAction(
  '[Order] Add Item',
  props<{
    request: LineItemRequest | BookingRequest;
  }>(),
);

export const addRentalItem = createAction(
  '[Order] Add Rental Item',
  props<{ request: BookingRequest }>(),
);

export const addRetailItem = createAction(
  '[Order] Add Retail Item',
  props<{ request: LineItemRequest }>(),
);

export const addItemSuccess = createAction(
  '[Order] Add Item Success',
  props<{order: Order; lastAddedItem: Booking | LineItem}>(),
);

export const addItemFailure = createAction(
  '[Order] Add Item Failure',
  props<{error: Error}>(),
);

/**
 * Remove item from an order
 */
export const removeItem = createAction(
  '[Order] Remove Item',
  props<{item: Booking | LineItem; order: Order}>(),
);

export const removeRentalItem = createAction(
  '[Order] Remove Rental Item',
  props<{item: Booking; order: Order}>(),
);

export const removeRetailItem = createAction(
  '[Order] Remove Retail Item',
  props<{item: LineItem; order: Order}>(),
);

export const removeItemSuccess = createAction(
  '[Order] Remove Item Success',
  props<{order: Order; item: Booking | LineItem}>(),
);

export const removeItemFailure = createAction(
  '[Order] Remove Item Failure',
  props<{error: Error; item: Booking | LineItem}>(),
);

export const submitPromoCode = createAction(
  '[Order] Submit Promo Code',
  props<{order: Order; code: string}>(),
);

export const clearSubmittingPromoCode = createAction(
  '[Order] Clear Submitting Promo Code',
);

export const submitPromoCodeSuccess = createAction(
  '[Order] Submit Promo Code Success',
  props<{order: Order}>(),
);

export const submitPromoCodeFailure = createAction(
  '[Order] Submit Promo Code Failure',
  props<{error: Error}>(),
);

export const removePromoCode = createAction(
  '[Order] Remove Promo Code',
  props<{order: Order}>(),
);

export const removePromoCodeSuccess = createAction(
  '[Order] Remove Promo Code Success',
  props<{order: Order}>(),
);

export const removePromoCodeFailure = createAction(
  '[Order] Remove Promo Code Failure',
  props<{error: Error}>(),
);

/**
 * Tip processing
 */
export const submitTip = createAction(
  '[Order] Submit Tip',
  props<{order: Order; tip: TipUpdatedEvent}>(),
);

export const submitTipSuccess = createAction(
  '[Order] Submit Tip Success',
  props<{order: Order}>(),
);

export const submitTipFailure = createAction(
  '[Order] Submit Tip Failure',
  props<{error: Error}>(),
);
